/* eslint-disable react/destructuring-assignment */
import { Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';

import { useContext, memo } from 'react';
import classNames from 'classnames';
import Caption from '../../Caption/Caption';
import List from '../../List/List';
import ListItem from '../../List-Item/ListItem';
import Icons from '../../../../configs/icon.config';
import CustomModal from '../../Modal/Modal';
import { injectReducer } from '../../../../app/index';
import reducer from './store';
import { closeDialog, leargeFooterState, openDialog } from './store/stateSlice';
import { TourContext } from '../../../layout';
import { authState } from '../../../../app/auth/authSlice';
import './styles.scss';

export interface LargeFooterTopProps {
  data?: any[] | undefined;
}

const LargeFooterTopData: any[] = [
  {
    caption_en: '+880-2-8823542, Ext:3200',
    caption_bn: '+880-2-8823542, Ext:3200',
    captionColor: 'white',
    captionSize: 'lg',
    hasBadge: false,
    hasNavlink: false,
    isActive: false,
    badgeColor: '#d10d74',
    icon: 'telephone',
  },
  {
    caption_en: 'it-support@brac.net',
    caption_bn: 'it-support@brac.net',
    captionColor: 'white',
    captionSize: 'lg',
    hasBadge: false,
    hasNavlink: false,
    isActive: false,
    badgeColor: '#d10d74',
    icon: 'mail',
  },
];

injectReducer('leargeFooter', reducer);

function LargeFooterTop() {
  const footerTour: any = useContext(TourContext);
  const dispatch = useDispatch();
  const { dialogOpen } = useSelector(leargeFooterState);
  const { profile } = useSelector(authState);

  return (
    <div className="flex flex-col md:flex-row md:pl-[120px] pl-[20px] md:pt-[50px] pt-[20px] md:pr-[50px] pr-[30px] pb-[30px] ">
      <div className="md:w-1/3 pb-[10px]">
        <Row className="py-4">
          <Caption
            text_en="Need some help?"
            text_bn="সাহায্য দরকার?"
            fontWeight="extrabold"
            fontSize="2xl"
            color="white"
          />
        </Row>
        <div className="text-[13px] text-pink-600 dark:text-[#EB3E8E]">
          <List data={LargeFooterTopData} />
        </div>
      </div>
      <div className="flex items-start justify-start 2xl:justify-center transition transform hover:-translate-y-1 motion-reduce:transition-none motion-reduce:hover:transform-none md:w-1/3 cursor-pointer py-4 ">
        <button
          className={classNames({
            'pointer-events-none': profile?.user_settings?.guided_tour,
          })}
          // className="w-[215px]"
          ref={footerTour.impContactsRef}
        >
          <ListItem
            caption_en="Important contacts"
            caption_bn="জরুরী ফোন নম্বর"
            hasBadge={false}
            captionSize="2xl"
            captionColor="white"
            captionWeight="extrabold"
            icon="important"
            iconsize="20px"
            iconColor="text-pink-600 hover:text-pink-700 dark:text-[#EB3E8E] dark:hover:text-pink-600"
            styles={{ cursor: 'pointer', marginLeft: '15px' }}
            onClick={() => dispatch(openDialog())}
          />
        </button>
      </div>
      {dialogOpen && (
        <CustomModal
          visible={dialogOpen}
          onClose={() => dispatch(closeDialog())}
        />
      )}
      <div className="md:w-1/3 flex justify-start 2xl:justify-center">
        <div>
          <Row className="py-4 md:ml-8 lg:ml-0 md:px-0 px-1 mb-4">
            <Caption
              text_en="Join the conversation"
              text_bn="কথোপকথনে যোগ দিতে"
              fontWeight="extrabold"
              fontSize="2xl"
              color="white"
            />
          </Row>
          <Row className="cursor-pointer ml-2">
            <div className="flex gap-6">
              <div
                className=" transition transform hover:-translate-y-1 motion-reduce:transition-none motion-reduce:hover:transform-none"
                style={{ color: '#EB3E8E', fontSize: '2.5rem' }}
              >
                <a
                  className="social-icon text-pink-600  hover:text-pink-700 dark:text-[#EB3E8E] dark:hover:text-pink-600"
                  href="https://www.facebook.com/BRACWorld/"
                  target="_blank"
                  rel="noreferrer"
                >
                  {Icons.facebook}
                </a>
              </div>
              <div
                className="transition transform hover:-translate-y-1 motion-reduce:transition-none motion-reduce:hover:transform-none hover:shadow-lg hover:shadow-pink-800"
                style={{ color: '#EB3E8E', fontSize: '2.5rem' }}
              >
                <a
                  href="https://twitter.com/bracworld"
                  className="social-icon text-pink-600 hover:text-pink-700 dark:text-[#EB3E8E] dark:hover:text-pink-600"
                  target="_blank"
                  rel="noreferrer"
                >
                  {Icons.twitter}
                </a>
              </div>
              <div
                className="transition transform hover:-translate-y-1 motion-reduce:transition-none motion-reduce:hover:transform-none hover:shadow-lg hover:shadow-pink-800"
                style={{ color: '#EB3E8E', fontSize: '2.5rem' }}
              >
                <a
                  href="https://www.youtube.com/bracworld"
                  className="social-icon text-pink-600 hover:text-pink-700 dark:text-[#EB3E8E] dark:hover:text-pink-600"
                  target="_blank"
                  rel="noreferrer"
                >
                  {Icons.youtube}
                </a>
              </div>
              <div
                className="transition transform hover:-translate-y-1 motion-reduce:transition-none motion-reduce:hover:transform-none hover:shadow-lg hover:shadow-pink-800"
                style={{ color: '#EB3E8E', fontSize: '2.5rem' }}
              >
                <a
                  href="https://www.instagram.com/bracworld/"
                  className="social-icon text-pink-600 hover:text-pink-700 dark:text-[#EB3E8E] dark:hover:text-pink-600"
                  target="_blank"
                  rel="noreferrer"
                >
                  {Icons.instagram}
                </a>
              </div>
              <div
                className="transition transform hover:-translate-y-1 motion-reduce:transition-none motion-reduce:hover:transform-none hover:shadow-lg hover:shadow-pink-800"
                style={{ color: '#EB3E8E', fontSize: '2.5rem' }}
              >
                <a
                  href="https://www.linkedin.com/company/brac"
                  className="social-icon text-pink-600 hover:text-pink-700 dark:text-[#EB3E8E] dark:hover:text-pink-600"
                  target="_blank"
                  rel="noreferrer"
                >
                  {Icons.linkedin}
                </a>
              </div>
            </div>
          </Row>
        </div>
      </div>
    </div>
  );
}

// LargeFooterTop.defaultProps = {
//   data: LargeFooterTopData,
//   titleLeft: 'Need Some Help?',
//   titleRight: 'Join the conversation',
// };

export default memo(LargeFooterTop);
